import { IClientContactData } from './IClientContact';

// The BackEnd requires that a POST request for a ClientOrderContact have a specific structure.
// These interfaces and functions produce that structure.

export interface ICreateContactData {
  firstName: string;
  middleName?: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
}

export interface ICreateClientOrderContactRequest {
  clientUserId?: string;
  contactData?: ICreateContactData;
  companyName: string;
  functions: string[];
  notes?: string;
}

export const convertFromIClientContactDataToICreateClientOrderContactRequest = (
  data: IClientContactData
): ICreateClientOrderContactRequest => {
  //the POST request accepts an id xor contactData. NOT BOTH!
  let request: ICreateClientOrderContactRequest = {
    clientUserId: data.id,
    companyName: data.companyName,
    functions: data.functions,
    notes: data.notes,
  };
  if (!request.clientUserId) {
    request.contactData = {
      firstName: data.firstName,
      middleName: data.middleName,
      lastName: data.lastName,
      emailAddress: data.email,
      phoneNumber: data.phoneNumber,
    };
  }
  return request;
};
